import React from 'react';
import PropTypes from 'prop-types';

const HighlightsPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M21.34 6.446a7.277 7.277 0 0 1-1.656 1.029c-1.437-.298-3.008-.34-4.696-.072-7.724 1.223-11.143 7.85-10.086 14.523a12.177 12.177 0 0 0 2.833 6.095 12.96 12.96 0 0 1-5.241-8.514C1.371 12.415 6.436 5.137 14.21 3.983c2.809-.418 6.114-.117 8.337 1.091-.31.508-.716.964-1.207 1.372zm3.624 8.019s-1.178-3.794-4.999-4.966c3.821-1.17 5-4.964 5-4.964s1.278 3.893 5 4.964c-3.822 1.172-5 4.966-5 4.966zm-7.828 10.17l-5.228 3.385a.5.5 0 0 1-.753-.555l1.624-5.777a.5.5 0 0 0-.158-.517l-4.87-4.124a.5.5 0 0 1 .324-.882h6.404a.5.5 0 0 0 .474-.343l1.98-5.991a.5.5 0 0 1 .95 0l1.911 5.785a.8.8 0 0 0 .76.55h6.186a.5.5 0 0 1 .324.88l-4.722 4a.8.8 0 0 0-.253.827l1.571 5.592a.5.5 0 0 1-.753.555l-5.227-3.386a.5.5 0 0 0-.544 0z"
    />
  );
};

HighlightsPath.propTypes = {
  fill: PropTypes.string,
};

export default HighlightsPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/highlights.jsx